var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnicargoDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 4.6875C9.70941 4.6875 9.21875 4.19684 9.21875 3.59375V0H3.625C2.67728 0 1.90625 0.771031 1.90625 1.71875V14.2812C1.90625 15.229 2.67728 16 3.625 16H12.375C13.3227 16 14.0938 15.229 14.0938 14.2812V4.6875H10.3125ZM4.46875 11.25H6.74125C7.00012 11.25 7.21 11.4599 7.21 11.7188C7.21 11.9776 7.00012 12.1875 6.74125 12.1875H4.46875C4.20988 12.1875 4 11.9776 4 11.7188C4 11.4599 4.20988 11.25 4.46875 11.25ZM4 9.21875C4 8.95988 4.20988 8.75 4.46875 8.75H11.3438C11.6026 8.75 11.8125 8.95988 11.8125 9.21875C11.8125 9.47762 11.6026 9.6875 11.3438 9.6875H4.46875C4.20988 9.6875 4 9.47762 4 9.21875ZM11.3438 6.25C11.6026 6.25 11.8125 6.45988 11.8125 6.71875C11.8125 6.97762 11.6026 7.1875 11.3438 7.1875H4.46875C4.20988 7.1875 4 6.97762 4 6.71875C4 6.45988 4.20988 6.25 4.46875 6.25H11.3438Z",
    fill: "#1D4650"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1562 3.59466C10.1562 3.68081 10.2263 3.75091 10.3125 3.75091H13.8848C13.7991 3.59259 13.6888 3.44719 13.5562 3.32178L10.543 0.471094C10.4261 0.360469 10.2958 0.268188 10.1563 0.195312V3.59466H10.1562Z",
    fill: "#1D4650"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnicargoDocument);
export default __webpack_public_path__ + "static/media/unicargo-document.41088db92a875d685b39305f3bdfe580.svg";
export { ForwardRef as ReactComponent };